<template>
    <v-container class="container">
        <v-card class="intro-page" elevation="4">
            <div class="intro-page__illustration">
                <InvoicesTrialPlanIllustration />
            </div>
            <h4 class="intro-page__title">
                {{ $t("heading.billing.noData.title") }}
            </h4>
            <div class="intro-page__desc p-lg">
                {{ $t("heading.billing.noData.text") }}
            </div>
            <div class="intro-page__actions">
                <v-btn
                    :to="`/instances`"
                    color="primary"
                    x-large
                    elevation="0"
                >
                    <span class="white--text">
                        {{ $t("button.dashboard.back") }}
                    </span>
                </v-btn>
            </div>
        </v-card>
    </v-container>
</template>

<script>
    import InvoicesTrialPlanIllustration from "./illustrations/trial-plan-invoices.vue";

    export default {
        components: {
            InvoicesTrialPlanIllustration
        },
    }
</script>